import types from './types';

const actions = {
  TOGGLE_LOADER(store: any) {
    store.commit(types.mutations.SET_SHOW_LOADER, !store.state.showLoader);
  }
};

export default actions;
